module.exports = __webpack_public_path__ + "static/media/sort-desc-arrow.0cba7571.svg";